import REDUCER_NAME from './reducer-name.js';

export const selectCoolOffPeriodOn = state => state[REDUCER_NAME].coolOffPeriodOn;
export const selectCoolOffTimeStamp = state => state[REDUCER_NAME].coolOffTimeStamp;
export const selectPanicReason = state => state[REDUCER_NAME].panicReason;
export const selectPanicToken = state => state[REDUCER_NAME].panicToken;
export const selectIsInGame = state => state[REDUCER_NAME].isInGame;
export const selectDuration = state => state[REDUCER_NAME].duration;
export const selectTimerId = state => state[REDUCER_NAME].timerId;
export const selectCoolOffTimerId = state => state[REDUCER_NAME].coolOffTimerId;
export const selectRealityCheckTimeReached = state => state[REDUCER_NAME].realityCheckTimeReached;
export const selectRealityCheckTimeReachedFromWebsocket = state =>
	state[REDUCER_NAME].realityCheckTimeReachedFromWebsocket;
export const selectRealityCheckCoolOffTimeReachedFromWebsocket = state =>
	state[REDUCER_NAME].realityCheckTimeCoolOffReachedFromWebsocket;
export const selectBetSum = state => state[REDUCER_NAME].betSum;
export const selectTotalWagered = state => state[REDUCER_NAME].totalWagered;
export const selectPlayTimeHours = state => state[REDUCER_NAME].playTimeHours;
export const selectPlayTimeMinutes = state => state[REDUCER_NAME].playTimeMinutes;
export const selectNotLosing = state => state[REDUCER_NAME].notLosing;
export const selectGamePlayStarted = state => state[REDUCER_NAME].gamePlayStarted;
export const selectNotificationId = state => state[REDUCER_NAME].notificationId;
export const selectApiError = state => state[REDUCER_NAME].apiError;
